import { request } from './_request';
import { notification } from 'antd';

const monthNames = [
  "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio",
  "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
];

export const getPuestos = () => {
  const user = JSON.parse(localStorage.getItem('@@auth_user'));

  return async (dispatch) => {
    dispatch({ type: 'LOADING_PUESTOS', payload: true });

    try {
      const response = await request.get('/puestos', {
        headers: { Authorization: `Bearer ${user.token}` },
      });

      if (response.data.error === false) {
        dispatch({ type: 'SUCCESS_PUESTOS', payload: response.data.result });
      } else {
        dispatch({
          type: 'ERROR_PUESTOS',
          payload: { message: response.data.message || 'Error desconocido' },
        });
      }
    } catch (error) {
      dispatch({
        type: 'ERROR_PUESTOS',
        payload: { message: error.message || 'Error en la solicitud' },
      });
    }
  };
};

export const createPuesto = (data) => {
  const user = JSON.parse(localStorage.getItem('@@auth_user'));

  return async (dispatch) => {
    dispatch({ type: 'LOADING_PUESTO', payload: true });

    try {
      const response = await request.post('/puestos', data, {
        headers: { Authorization: `Bearer ${user.token}` },
      });

      if (response.data.error === false) {
        dispatch({ type: 'SUCCESS_CREAR_PUESTO', payload: response.data.result });

        notification.success({
          message: 'Puesto creado correctamente',
          description: 'El puesto se ha creado exitosamente.',
          placement: 'topRight',
        });
      } else {
        dispatch({
          type: 'ERROR_CREAR_PUESTO',
          payload: { message: response.data.message || 'Error desconocido' },
        });
      }
    } catch (error) {
      dispatch({
        type: 'ERROR_CREAR_PUESTO',
        payload: { message: error.message || 'Error en la solicitud' },
      });

      notification.error({
        message: 'Error al crear el puesto',
        description: 'Hubo un problema al guardar el puesto.',
        placement: 'topRight',
      });
    }
  };
};

export const updatePuesto = (id, data) => {
  const user = JSON.parse(localStorage.getItem('@@auth_user'));

  return async (dispatch) => {
    dispatch({ type: 'LOADING_PUESTO', payload: true });

    try {
      const response = await request.put(`/puestos/${id}`, data, {
        headers: { Authorization: `Bearer ${user.token}` },
      });

      if (response.data.error === false) {
        dispatch({ type: 'SUCCESS_ACTUALIZAR_PUESTO', payload: response.data.result });

        notification.success({
          message: 'Puesto actualizado correctamente',
          description: 'El puesto ha sido actualizado exitosamente.',
          placement: 'topRight',
        });
      } else {
        dispatch({
          type: 'ERROR_ACTUALIZAR_PUESTO',
          payload: { message: response.data.message || 'Error desconocido' },
        });

        notification.error({
          message: 'Error al actualizar el puesto',
          description: response.data.message || 'Hubo un problema al actualizar el puesto.',
          placement: 'topRight',
        });
      }
    } catch (error) {
      dispatch({
        type: 'ERROR_ACTUALIZAR_PUESTO',
        payload: { message: error.message || 'Error en la solicitud' },
      });

      notification.error({
        message: 'Error al actualizar el puesto',
        description: 'Hubo un problema al actualizar el puesto.',
        placement: 'topRight',
      });
    }
  };
};

export const getIndicadores = (year) => {
  const user = JSON.parse(localStorage.getItem('@@auth_user'));
  const selectedYear = year || new Date().getFullYear();

  return async (dispatch) => {
    dispatch({ type: 'LOADING_INDICADORES', payload: true });

    try {
      const response = await request.get(`/indicadores_evaluacion?year=${selectedYear}`, {
        headers: { Authorization: `Bearer ${user.token}` },
      });

      if (response.data.error === false) {
        dispatch({ type: 'SUCCESS_INDICADORES', payload: response.data.result });
      } else {
        dispatch({
          type: 'ERROR_INDICADORES',
          payload: { message: response.data.message || 'Error desconocido' },
        });
      }
    } catch (error) {
      dispatch({
        type: 'ERROR_INDICADORES',
        payload: { message: error.message || 'Error en la solicitud' },
      });
    }
  };
};

export const createIndicador = (data) => {
  const user = JSON.parse(localStorage.getItem('@@auth_user'));

  return async (dispatch) => {
    dispatch({ type: 'LOADING_INDICADOR', payload: true });

    try {
      const response = await request.post('/indicadores_evaluacion', data, {
        headers: { Authorization: `Bearer ${user.token}` },
      });

      
      if (response.data.error === false) {
        dispatch({ type: 'SUCCESS_EDITAR_INDICADOR', payload: response.data.result });
        return response.data;
      } else {
        dispatch({
          type: 'ERROR_INDICADOR',
          payload: { message: response.data.message || 'Error desconocido' },
        });
        return response.data;
      }
    } catch (error) {
      dispatch({
        type: 'ERROR_INDICADOR',
        payload: { message: error.message || 'Error en la solicitud' },
      });
      return { error: true, message: error.message };
    }
  };
};

export const getIndicadoresPorPuesto = (year) => {
  const user = JSON.parse(localStorage.getItem('@@auth_user'));
  const selectedYear = year || new Date().getFullYear();

  return async (dispatch) => {
    dispatch({ type: 'LOADING_INDICADORES', payload: true });

    try {
      const response = await request.get(`/indicadores_evaluacion/puesto/${user.puesto}?year=${selectedYear}`, {
        headers: { Authorization: `Bearer ${user.token}` },
      });

      if (response.data.error === false) {
        dispatch({ type: 'SUCCESS_INDICADORES', payload: response.data.result });
      } else {
        dispatch({
          type: 'ERROR_INDICADORES',
          payload: { message: response.data.message || 'Error desconocido' },
        });
      }
    } catch (error) {
      dispatch({
        type: 'ERROR_INDICADORES',
        payload: { message: error.message || 'Error en la solicitud' },
      });
    }
  };
};

export const updateIndicador = (id, data) => {
  const user = JSON.parse(localStorage.getItem('@@auth_user'));

  return async (dispatch) => {
    dispatch({ type: 'LOADING_INDICADOR', payload: true });

    try {
      const response = await request.put(`/indicadores_evaluacion/${id}`, JSON.stringify(data), {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${user.token}`
        },
      });

      if (response.data.error === false) {
        dispatch({ type: 'SUCCESS_EDITAR_INDICADOR', payload: response.data.result });
        return response.data;
      } else {
        dispatch({
          type: 'ERROR_INDICADOR',
          payload: { message: response.data.message || 'Error desconocido' },
        });
        return response.data;
      }
    } catch (error) {
      dispatch({
        type: 'ERROR_INDICADOR',
        payload: { message: error.message || 'Error en la solicitud' },
      });
      return { error: true, message: error.message };
    }
  };
};



export const updateResultado = (data) => {
  const user = JSON.parse(localStorage.getItem('@@auth_user'));

  return async (dispatch) => {
    dispatch({ type: 'LOADING_RESULTADO', payload: true });

    try {
      const response = await request.post('/resultados_indicadores', JSON.stringify(data), {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${user.token}`
        },
      });

      if (response.data.error === false) {
        dispatch({ type: 'SUCCESS_ACTUALIZAR_RESULTADO', payload: response.data.result });

        notification.success({
          message: 'Resultado guardado',
          description: `El resultado para el mes de ${monthNames[data.mes - 1]} ha sido guardado exitosamente.`,
          placement: 'topRight',
        });

        if ([4, 20, 19].includes(user.puesto)) {
          dispatch(getIndicadores(data.year)); // Recargar los indicadores para administradores
        } else {
          dispatch(getIndicadoresPorPuesto(data.year)); // Recargar los indicadores para otros puestos
        }
      } else {
        dispatch({
          type: 'ERROR_ACTUALIZAR_RESULTADO',
          payload: { message: response.data.message || 'Error en la solicitud' },
        });

        notification.error({
          message: 'Error al guardar el resultado',
          description: response.data.message || 'Hubo un problema al guardar el resultado.',
          placement: 'topRight',
        });
      }
    } catch (error) {
      dispatch({
        type: 'ERROR_ACTUALIZAR_RESULTADO',
        payload: { message: error.message || 'Error en la solicitud' },
      });

      notification.error({
        message: 'Error al guardar el resultado',
        description: 'Hubo un problema al guardar el resultado.',
        placement: 'topRight',
      });
    }
  };
};